import React from 'react';
import { connect } from 'react-redux';

import { toggleModal, toggleSpinner } from 'apps/auth/actions/appAction';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';
import { AUTH_SEND_POST_COUNTRY_SELECT_TERMS } from 'apps/auth/constants/UrlConstants';
import { apiFetchData } from 'apps/auth/helpers/api';

const PostSelectCountryDisclaimer = (props) => {
    const confirmUrl = `${AUTH_SEND_POST_COUNTRY_SELECT_TERMS}?countryId=${props.toCountryId}`;

    const confirm = (e) => {
        e.preventDefault();
        props.toggleSpinner(true);
        apiFetchData(confirmUrl).finally(() => {
            props.toggleSpinner(false);
            props.toggleModal(false);
        });
    };

    return (
        <ModalComponent isVerticalCentered canCloseModal={false}>
            <InfoPage
                insideModalComponent
                iconName="bank-us-dollar-thin"
                iconColor="primary"
                headerText={props.disclaimer?.title}
                secondaryText={props.disclaimer?.content}
                primaryButtonCaption={props.submitDisclaimer}
                primaryButtonOnClick={confirm}
                primaryButtonType="link"
                primaryButtonLink={confirmUrl}
            />
        </ModalComponent>
    );
};

const mapStateToProps = (state) => {
    return {
        submitDisclaimer: state.messages.pageMessages.submitDisclaimer,
    };
};
export default connect(mapStateToProps, { toggleSpinner, toggleModal })(PostSelectCountryDisclaimer);
